import React, { useState } from "react";

// React Bootstrap
import Container from "react-bootstrap/Container";

// Material UI
import { LinearProgress } from "@mui/material";

// Components
import EMI from "../components/Form/EMI";
import GGPI from "../components/Form/GGPI";
import AIO from "../components/Form/AIO";
import IGC from "../components/Form/IGC";
import PG from "../components/Form/PG";
import Resultado from "./Resultado";

import {
	formDataEMI,
	formDataGGPI,
	formDataAIO,
	formDataIGC,
	formDataPG,
} from "../assets/data/form.js";

const FormGI = () => {
	const [page, setPage] = useState(1);

	const [emi, setEMI] = useState({});
	const [ggpi, setGGPI] = useState({});
	const [aio, setAIO] = useState({});
	const [igc, setIGC] = useState({});
	const [pg, setPG] = useState({});

	const [nome_organizacao, setNomeOrganizacao] = useState("");

	const handleChangeEMI = (e) => {
		setEMI({
			...emi,
			[e.target.name]: parseInt(e.target.value),
		});
	};

	const handleChangeGGPI = (e) => {
		setGGPI({
			...ggpi,
			[e.target.name]: parseInt(e.target.value),
		});
	};

	const handleChangeAIO = (e) => {
		setAIO({
			...aio,
			[e.target.name]: parseInt(e.target.value),
		});
	};

	const handleChangeIGC = (e) => {
		setIGC({
			...igc,
			[e.target.name]: parseInt(e.target.value),
		});
	};

	const handleChangePG = (e) => {
		setPG({
			...pg,
			[e.target.name]: parseInt(e.target.value),
		});
	};

	const calcularNovamente = () => {
		setPage(1);

		setEMI({});
		setGGPI({});
		setAIO({});
		setIGC({});
		setPG({});
	};

	function proximaPagina() {
		if (page === 6) return;
		setPage((page) => page + 1);
	}

	function voltarPagina() {
		if (page === 1) return;
		setPage((page) => page - 1);
	}

	return (
		<Container className="mt-5">
			<LinearProgress
				className="mb-3"
				variant="determinate"
				value={page * 16.666}
			/> 

			{page === 1 && (
				<EMI
					values={emi}
					handleChange={handleChangeEMI}
					proximaPagina={proximaPagina}
					data={formDataEMI}
                    nome_organizacao={nome_organizacao}
                    setNomeOrganizacao={setNomeOrganizacao}
				/>
			)}
			{page === 2 && (
				<GGPI
					handleChange={handleChangeGGPI}
					values={ggpi}
					proximaPagina={proximaPagina}
					voltarPagina={voltarPagina}
					data={formDataGGPI}
				/>
			)}
			{page === 3 && (
				<AIO
					handleChange={handleChangeAIO}
					values={aio}
					proximaPagina={proximaPagina}
					voltarPagina={voltarPagina}
					data={formDataAIO}
				/>
			)}
			{page === 4 && (
				<IGC
					handleChange={handleChangeIGC}
					values={igc}
					proximaPagina={proximaPagina}
					voltarPagina={voltarPagina}
					data={formDataIGC}
				/>
			)}
			{page === 5 && (
				<PG
					handleChange={handleChangePG}
					values={pg}
					proximaPagina={proximaPagina}
					voltarPagina={voltarPagina}
					data={formDataPG}
				/>
			)}

			{page === 6 && (
				<Resultado
					EMI={emi}
					GGPI={ggpi}
					AIO={aio}
					IGC={igc}
					PG={pg}
                    nome_organizacao={nome_organizacao}
					calcularNovamente={calcularNovamente}
				/>
			)}
		</Container>
	);
};

export default FormGI;
